import React from "react";
import { Icon } from "src/components";
import styled from "styled-components";

const EmptyReward = styled.div`
  width: 38px;
  padding: 4px;
  display: inline-block;
  vertical-align: middle;
`;
const RewardIcon = styled(Icon)`
  width: 38px;
  padding: 4px;
  display: inline-block;
  vertical-align: middle;
`;

interface IProps {
  rewards?: string[] | undefined;
}

const ProductReward = ({ rewards }: IProps): JSX.Element => {
  if (!rewards || rewards?.length === 0) {
    return <EmptyReward />;
  }

  return <RewardIcon name="recompense" size={30} />;
};

export default ProductReward;
